import { render } from "./AppTaskbar.vue?vue&type=template&id=4b32cd5a&scoped=true"
import script from "./AppTaskbar.vue?vue&type=script&lang=js"
export * from "./AppTaskbar.vue?vue&type=script&lang=js"

import "./AppTaskbar.vue?vue&type=style&index=0&id=4b32cd5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b32cd5a"]])

export default __exports__